export default __webpack_public_path__ + "static/media/palestine.bac429c7.jpg";